import { gql } from '@/utilities/gql';
import { makeGqlQuery } from '@/utilities/gqlQuery';
import { NARRATIVE_CARD_FRAGMENT } from '@/components/NarrativeCard';

const QUERY = gql(
  `
  query CompanyNarrativesGetNarrativesByCompanyCanonical($canonicalUrl: String!) {
    NarrativesByCompanyCanonical(companyCanonicalUrl: $canonicalUrl) {
      id
      company {
        id
        tickerSymbol
      }
      ...NarrativeCardFields
    }
  }
`,
  [NARRATIVE_CARD_FRAGMENT]
);

export const useCompanyNarratives = makeGqlQuery(QUERY, {
  tags: ['narrative', 'narrative-company-report-list'],
  staleTime: 0,
});
